import { __rest } from 'tslib';
import React from 'react';
import { Close } from '../../icons/Close/Close.js';
import { useTheme } from '../../theme/Theme.js';
import { Button } from '../Button/Button.js';
import { Box } from '../../grid/Box/styled.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { useTranslation } from '../../locale/useTranslation.js';
import { Root } from './styled.js';
import { useSize, useStyles } from './hooks.js';

const Modal = (_a) => {
    var { footer, okButtonProps, cancelButtonProps, okText = 'Принять', cancelText = 'Отмена', scroll = 'body', size = 'medium', confirmLoading, closeIconTooltip, title } = _a, props = __rest(_a, ["footer", "okButtonProps", "cancelButtonProps", "okText", "cancelText", "scroll", "size", "confirmLoading", "closeIconTooltip", "title"]);
    const theme = useTheme();
    const width = useSize({ size, width: props.width });
    const [style, bodyStyle] = useStyles({
        scroll,
        centered: props.centered,
        style: props.style,
        bodyStyle: props.bodyStyle,
    });
    const noFooter = footer === null;
    const titleProp = React.useMemo(() => {
        if (!title)
            return title;
        if (Array.isArray(title))
            return (React.createElement(Box, { "$display": 'flex', "$flexDirection": 'column', "$alignItems": 'flex-start', "$gap": 8 }, title.map(node => node)));
        return title;
    }, [title]);
    const footerNode = React.useMemo(() => {
        var _a, _b;
        if (typeof footer === 'undefined') {
            return (React.createElement(Box, { "$display": 'inline-flex', "$alignItems": 'center', "$gap": 12 },
                React.createElement(Button, Object.assign({ "data-testid": 'tend-ui-modal-cancel-button', variant: 'secondary' }, cancelButtonProps, { onClick: (_a = cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.onClick) !== null && _a !== void 0 ? _a : props.onCancel }), (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.children) || cancelText),
                React.createElement(Button, Object.assign({ "data-testid": 'tend-ui-modal-ok-button', loading: confirmLoading }, okButtonProps, { onClick: (_b = okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.onClick) !== null && _b !== void 0 ? _b : props.onOk }), (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.children) || okText)));
        }
        if (Array.isArray(footer))
            return (React.createElement(Box, { "$display": 'inline-flex', "$alignItems": 'center', "$gap": 12 }, footer.map(node => node)));
        return footer;
    }, [
        cancelButtonProps,
        cancelText,
        confirmLoading,
        footer,
        okButtonProps,
        okText,
        props.onCancel,
        props.onOk,
    ]);
    const t = useTranslation();
    const tooltipProps = React.useMemo(() => {
        if (!closeIconTooltip)
            return { title: t('general.close') };
        return closeIconTooltip;
    }, [closeIconTooltip, t]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-modal' }, props, { "$theme": theme, "$noFooter": noFooter, "$scroll": scroll, title: titleProp, footer: footerNode, width: width, style: style, bodyStyle: bodyStyle, closeIcon: React.createElement(Tooltip, Object.assign({}, tooltipProps),
            React.createElement(Close, null)) })));
};
Modal.displayName = 'Modal';

export { Modal };
//# sourceMappingURL=Modal.js.map
